import { collection_name } from "@/types/projectConsts";

const productKeys = {
  all: [{ scope: collection_name.ECOM_PRODUCT_LINES }] as const,

  list: (params?: any) =>
    [{ scope: "dmvt", type: "list", ...params }] as const,

  detail: (ma_vt?: string) =>
    [{ scope: "dmvt", type: "detail", ma_vt }] as const,

  count: (params?: any) =>
    [{ scope: "dmvt", type: "count", ...params }] as const,

  homeList: (ma_danh_muc_cty?: string) =>
    [{ scope: "dmvt", type: "homeList", ma_danh_muc_cty }] as const,

  relatedProducts: (ma_nvt?: string) =>
    [{ scope: "dmvt", type: "relatedProducts", ma_nvt }] as const,
};

export default productKeys;
